import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { Response, DeletedItems} from '../models';

@Injectable({ providedIn: 'root' })

export class TrashService {

  constructor(
    private http: HttpClient) { }


    finalDeleteEntity(idEntity: string, type: string): Promise<Response> {
      return this.http.post<Response>(`${environment.apiUrl}/FinalDeleteEntity`,
        {
          id_entity: idEntity,
          type
        }
      ).toPromise();
    }

    finalDeleteMultipleEntities(d : {id_entity : string, type: string}[]): Promise<Response> {  
      return this.http.post<Response>(`${environment.apiUrl}/FinalDeleteMultipleEntities`,
        d
      ).toPromise();
    }

    getDeletedItem(columnName?: string, orderBy?: string): Promise<{ deleted_items: DeletedItems[] }> {
      let url: string;
      if (columnName && orderBy) {
        url = `${environment.apiUrl}/Trashbin-GetDeletedItems?key=${columnName}&orderby=${orderBy}`;
      } else {
        url = `${environment.apiUrl}/Trashbin-GetDeletedItems`;
      }
      return this.http.get<{ deleted_items: DeletedItems[]}>(url).toPromise();
    }

    getAdminDeletedItem(columnName?: string, orderBy?: string): Promise<{ deleted_items: DeletedItems[] }> {
      let url: string;
      if (columnName && orderBy) {
        url = `${environment.apiUrl}/Trashbin-GetAdminDeletedItems?key=${columnName}&orderby=${orderBy}`;
      } else {
        url = `${environment.apiUrl}/Trashbin-GetAdminDeletedItems`;
      }
      return this.http.get<{ deleted_items: DeletedItems[]}>(url).toPromise();
    }

    restoreEntity(idEntity: string, type: string, id_parent:string, is_project_parent:boolean): Promise<Response> {
      return this.http.post<Response>(`${environment.apiUrl}/RestoreEntity`,
        {
          id_entity: idEntity,
          type,
          id_parent,
          is_parent_a_project: is_project_parent
        }
      ).toPromise();
    }

  }

